import buildComponent from './utils/build-component';
import slider from './slider';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initFunction: ($el, params) => {
    let sliderComponent;
    const $buttonPrev = $el.querySelector(`.${nameSpace}__button-prev`);
    const $buttonNext = $el.querySelector(`.${nameSpace}__button-next`);
    let slideToTimeout;

    //
    // Methods
    //

    function onReachEnd() {
      const swi = sliderComponent.swiperInstance;
      if (slideToTimeout) {
        clearTimeout(slideToTimeout)
      }
      slideToTimeout = setTimeout(() => swi.slideTo(0), 3000)
    }

    function onSlideChange() {
      if (slideToTimeout) {
        clearTimeout(slideToTimeout)
      }
    }

    //
    // Life Cycle
    //

    //
    // Procedures
    //

    sliderComponent = slider(nameSpace).init({
      $el,
      customParams: {
        swiperConfig: {
          autoplay: true,
          slidesPerView: 'auto',
          on: {
            reachEnd: onReachEnd,
            slideChange: onSlideChange,
          },
          navigation: {
            prevEl: $buttonPrev,
            nextEl: $buttonNext,
          },
        },
      }
    });

    //
    // Listeners / Observers
    //

    //
    // Public API
    //

    return {
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/pages-slider.js